import { render, staticRenderFns } from "./task.vue?vue&type=template&id=01067834&"
import script from "./task.vue?vue&type=script&lang=ts&"
export * from "./task.vue?vue&type=script&lang=ts&"
import style0 from "./task.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports